import type { Quantity } from '~/graphql/graphql';

export type BuyListItemChange = {
  quantity: Quantity;
  piecesPerBundleOverride: number | undefined;
  clearPiecesPerBundleOverride: boolean;
};

export function buyListItemChange(
  quantity: Quantity,
  piecesPerBundleOverride: number | undefined,
  savedPiecesPerBundleOverride: number | undefined
): BuyListItemChange {
  return {
    quantity,
    piecesPerBundleOverride,
    clearPiecesPerBundleOverride:
      piecesPerBundleOverride === undefined &&
      savedPiecesPerBundleOverride !== undefined,
  };
}
